import React, { useContext, useRef } from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import FormData from './Form.context';
import Label from './Label.form';
import ErrorMsg from './ErrorMsg.form';

const Phone = props => {
	const {
		required = false,
		name,
	} = props;

	const { control } = useContext(FormData);
	const phoneRef = useRef(null);

	return (
		<div className='form-group-old'>
			<Label {...props} />

			<Controller
				control={control}
				name={name}
				render={({ onChange, onBlur, value }) => (
					<PhoneInput
						onChange={onChange}
						onBlur={onBlur}
						selected={value}
						country={'us'}
						ref={phoneRef}
					/>
				)}
				rules={{ required: { value: required, message: 'Required' } }}
			/>

			<ErrorMsg {...props} />
		</div>
	);
};

export default Phone;
